export default function getRandVal(){
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4() + Math.random());
}

export const getTime = function (time,type='day',sel){
    let times;
    if(sel){
        times = Number(String(time).replace(/\./g,'/'));
    }else{
        times = time.replace(/\./g, '-');
    }
    if(times){
        var now = new Date(times);
    }else{
        var now = new Date();
    }

    var year = now.getFullYear(); //得到年份
    var month = now.getMonth();//得到月份
    var date = now.getDate();//得到日期
    month = month + 1;
    if (month < 10) month = "0" + month;
    if (date < 10) date = "0" + date;
    var time = "";
    if(type == 'day'){
        time = year + "-" + month + "-" + date;
    }else if(type == 'month'){
        time = year + "-" + month;
    }

    return time;

}

export const returnDay = function (type) {
    var now = new Date();
    if(type == 'next'){
        now.setTime(now.getTime()+24*60*60*1000);
    }
    var day = now.getFullYear()+"-" + (now.getMonth()+1) + "-" + now.getDate() + ' 00:00:00';
    console.log(day);
    return day;
}

export const timestampToTime = function (timestamp) {    
    if(!timestamp)return "";
    var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    var D = (date.getDate() < 10? "0" + date.getDate() : date.getDate() )+ ' ';
    var h = (date.getHours() < 10? "0" + date.getHours():date.getHours() )+ ':';
    var m = (date.getMinutes() < 10? "0" + date.getMinutes() : date.getMinutes() )+ ':';
    var s = (date.getSeconds() < 10? "0" + date.getSeconds() : date.getSeconds());
    return Y+M+D + h + m + s;
}
const getHandledValue = num => {
    return num < 10 ? '0' + num : num
}
export const getDate = (timeStamp, startType) => {
    if(!timeStamp) return '';
    const d = new Date(timeStamp)
    const year = d.getFullYear()
    const month = getHandledValue(d.getMonth() + 1)
    const date = getHandledValue(d.getDate())
    const hours = getHandledValue(d.getHours())
    const minutes = getHandledValue(d.getMinutes())
    const second = getHandledValue(d.getSeconds())
    let resStr = ''
    if (startType === 'year') resStr = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + second
    else if (startType === 'day') resStr = year + '-' + month + '-' + date
    else if (startType === 'days') resStr = year + '.' + month + '.' + date
    else if (startType === 'minutes') resStr = hours + ':' + minutes
    else resStr = month + '-' + date + ' ' + hours + ':' + minutes
    return resStr
}

const returnBotData = function (data, show = true) {
    let arr = [];
    let colorOjb = [
      {
        "start": "#FA9D33" ,
        "end": "#FA9D33"
      } ,
      {
        "start": "#1182E2",
        "end": "#1182E2"
      },
      {
        "start": "#4CBEFF",
        "end": "#4CBEFF"
      },
      {
        "start": "#51F1F1",
        "end": "#51F1F1"
      },
      {
        "start": "#5ab1ef",
        "end": "#285575"
      },
      {
        "start": "#b5a2de",
        "end": "#6b5e85"
      },
      {
        "start": "#2fc7c9",
        "end": "#1a797a"
      },
      {
        "start": "#97b551",
        "end": "#57682e"
      },
      {
        "start": "#3340a6",
        "end": "#7177a4"
      },
      {
        "start": "#28a7b6",
        "end": "#7eabb0"
      },
      {
        "start": "#8d33b7",
        "end": "#a17bb3"
      },
      {
        "start": "#538d24",
        "end": "#77886a"
      },
      {
        "start": "#3181e3",
        "end": "#adc4e1"
      },
      {
        "start": "#182558",
        "end": "#3c4152"
      },
      {
        "start": "#5a4213",
        "end": "#5b5344"
      },
      {
        "start": "#1b959d",
        "end": "#7d9698"
      },
      {
        "start": "#b38937",
        "end": "#b2a489"
      },
      {
        "start": "#8e301e",
        "end": "#8a716c"
      },
      {
        "start": "#366417",
        "end": "#536349"
      },
      {
        "start": "#b79a25",
        "end": "#b9b08d"
      },
      {
        "start": "#208e3a",
        "end": "#62956e"
      },
      {
        "start": "#ba2254",
        "end": "#b48897"
      },
      {
        "start": "#21257c",
        "end": "#636481"
      }
    ]
    for(let i = 0;i<data.length;i++){
      let obj =  {
        value: Number(data[i].count),
        name: data[i].name,
        code: data[i].code,
        itemStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: colorOjb[i]? colorOjb[i].start : colorOjb[0].start // 0% 处的颜色
              },
              {
                offset: 1,
                color: colorOjb[i]? colorOjb[i].end : colorOjb[0].end // 100% 处的颜色
              }
            ],
            globalCoord: false // 缺省为 false
          }
        },
        label: {
          normal: {
            show: i == 0 ? true : show,
            textStyle: {
              color: colorOjb[0].start
            },
            formatter: "{b}",
          }
        },
        labelLine: {
            show: i == 0 ? true : show,
        }
      };
      arr.push(obj);
    }
    return arr;
}
export {returnBotData}


// WEBPACK FOOTER //
// ./src/assets/js/index.js